import { Trash, X } from 'lucide-solid'
import { Component } from 'solid-js'
import { AppSchema } from '../../../../common/types/schema'
import Button from '../../../shared/Button'
import Modal from '../../../shared/Modal'
import { chatStore, settingStore } from '../../../store'
import { useNavigate } from '@solidjs/router'
import { getOrCreateChatWithCharacter } from '/web/shared/aifans/lib/chat-util'

const RestartChatModal: Component<{
  chat?: AppSchema.Chat
  show: boolean
  close: () => void
}> = (props) => {
  const nav = useNavigate()

  const onRestart = () => {
    if (!props.chat) return
    chatStore.deleteChat(props.chat?._id, () => {
      props.close()
      const characterId = props.chat?.characterId
      if (characterId) {
        getOrCreateChatWithCharacter(characterId, (url) => {
          nav(url)
          settingStore.leftPanelMobile(false)
        })
      }
    })
  }
  return (
    <Modal
      show={props.show && !!props.chat}
      title="Confirm Restart Chat"
      close={props.close}
      footer={
        <>
          <Button schema="secondary" onClick={props.close}>
            <X />
            Cancel
          </Button>

          <Button schema="red" onClick={onRestart}>
            <Trash /> Restart
          </Button>
        </>
      }
    >
      <div class="flex flex-col items-center gap-4">
        <div>Are you sure you wish to restart this chat?</div>
        <div class="flex justify-center gap-4">{props.chat!.name}</div>
      </div>
    </Modal>
  )
}

export default RestartChatModal
